const SeoTwitter = `
  fragment SeoTwitter on SeoTwitter {
      description
      title
      username
  }
`

export default SeoTwitter
